/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { JobSearchContainer } from './Search.style';
import { JobPostList } from 'pages/jobs/JobPosts.style';
import moment from 'moment';
import { Skeleton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SampleCompany } from 'assert/images/Jobs/sampleCompany.svg';
import { useDispatch, useSelector } from 'react-redux';
import { timeMapping } from 'assert/OptionList';
import { handleGetSearchJobList } from 'redux/features/SearchSlice';
import { Button } from 'components';
import { useTranslation } from 'react-i18next';

export default function Jobs({ keyword }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [searchList, setSearchList] = useState([]);
  const [loading, setLoading] = useState(false);

  const { workTypeList, countryList } = useSelector(
    (state) => state?.DropdownReducer
  );

  useEffect(() => {
    setLoading(true);
    const payload = {
      keyword,
    };
    dispatch(handleGetSearchJobList(payload))
      .then((res) => {
        if (res?.data?.rows?.data?.length > 0) {
          setSearchList(res?.data?.rows?.data);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  return (
    <JobSearchContainer>
      <JobPostList>
        <div className="job-list-container job-list-search-container">
          {searchList?.length > 0 &&
            searchList?.map((list, index) => {
              const workIds =
                typeof list?.workTypeIds === 'string'
                  ? list.workTypeIds.split(',')
                  : Array.isArray(list?.workTypeIds)
                  ? list.workTypeIds
                  : [];
              const timeAgo = moment(list?.updated_At).fromNow(true);
              const [count, unit] = timeAgo?.split(' ');
              const formattedUnit = timeMapping[unit] || unit;
              return (
                <div
                  key={index}
                  className={'job-list-item'}
                  onClick={() => navigate(`/jobs-detail/${list?.jobPostId}`)}
                >
                  {list?.companyLogo ? (
                    <img
                      alt="company-logo"
                      className="job-list-company-logo"
                      src={list?.companyLogo}
                    />
                  ) : (
                    <SampleCompany className="job-list-sample-company-logo" />
                  )}
                  <div className="job-list-short-preview">
                    <div className='job-title'>{list?.jobTitle}</div>
                    <div className="job-companyname">{list?.companyName}</div>
                    <div className="job-list-types">
                      {list?.location?.map((item, index) => {
                        const ctr = countryList.find(
                          (ele) => ele.value === item.country
                        )?.label;
                        return (
                          <span key={index}>
                            {item?.city
                              ? item?.city + ', ' + ctr + ' '
                              : ctr + ' '}
                          </span>
                        );
                      })}
                    </div>
                    <div className="job-list-types">
                      {workIds?.map((itemId, index) => {
                        return (
                          <span key={index}>
                            {
                              workTypeList.find(
                                (workTypeItem) => workTypeItem.value == itemId
                              )?.label
                            }
                            {workIds?.length !== index + 1 && ',  '}
                          </span>
                        );
                      })}
                    </div>
                    <div className="job-list-post-time">
                      {count} {formattedUnit}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </JobPostList>
      {searchList?.length > 0 && (
        <div className="see-all-results">
          <Button
            variant="text"
            label="See All Job Results"
            onClick={() => {
              navigate(`/jobs?keyword=${keyword}`);
            }}
          />
        </div>
      )}
      {searchList?.length === 0 && loading && (
        <JobPostList isdisable={true}>
          <div className="job-list-container job-list-search-container">
            {[...Array(3)].map((index) => {
              return (
                <div key={index} className={'job-list-item'}>
                  <Skeleton
                    variant="circular"
                    width={60}
                    height={60}
                    animation="wave"
                  />
                  <div className="job-list-short-preview">
                    <Skeleton width={"100%"} animation="wave" />
                    <div className="job-companyname">
                      <Skeleton width={100} animation="wave" />
                    </div>
                    <div className="job-list-types">
                      <Skeleton width={"100%"} animation="wave" />
                    </div>
                    <div className="job-list-types">
                      <Skeleton width={"100%"} animation="wave" />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </JobPostList>
      )}
      {searchList?.length === 0 && !loading && keyword?.length > 0 && (
        <div className="no-data-found">
          <div>{t('Job.NoJobsFound')}</div>
        </div>
      )}
    </JobSearchContainer>
  );
}
